import { Button, Fade, Tooltip } from '@material-ui/core'
import React, { useState, useRef, useEffect, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import './ProductCard.css'
// import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
import FavouriteCheckbox from '@/custom/components/atoms/FavoriteCheckbox'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import Bidding from '@/custom/components/molecules/Bidding/BiddingItem'
import Buynow from '@/custom/components/molecules/Buynow/BuynowItem'
import Makeoffer from '@/custom/components/molecules/Makeoffer/MakeofferItem'
import { dateFormatFront, dateFormatFrontDate } from '@/custom/common/components'
import { handleRedirectInternal, currencyFormat } from '@/custom/common/components'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
// import Timer from '@/product/common/timer'
import Timer from '@/custom/common/timer'
import { FALLBACK_IMAGE } from '@/utils'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import { isValidHttpUrl } from '@/product/common/components'
import Share from '../../organisms/ProductView/Share'
import CustomTooltip from '../../organisms/CustomTooltip/CustomTooltip'
import { Height } from '@material-ui/icons'
import SignContext from '@/custom/context/signContext'
import { useMediaQuery } from '@material-ui/core'
import Popup from '../../organisms/Popup'
import ProductView from '../../organisms/ProductView'

const Grid = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { handleLoginPopup } = useContext(SignContext)
    const { setBidHistoryValue } = commonContext
    const { user, isAuthenticated } = authContext
    const { configVariables, allLocations } = customCommonContext
    const [productLocation, setProductLocation] = useState({})
    const [isHardOfferSelected, setHardOffer] = useState(false)
    const toggleHardOffer = () => {
        setHardOffer(!isHardOfferSelected)
    }
    const [activeTooltip, setActiveTooltip] = useState(null)
    const [clickedTooltip, setClickedTooltip] = useState(null)
    const handleToolTipClose = (index) => {
        if (activeTooltip === index && !clickedTooltip) {
            setActiveTooltip(null)
        }
    }
    const handleToolTipOpen = (index) => {
        if (!clickedTooltip) {
            setActiveTooltip(index)
        }
    }
    const handleToolIconClick = (event, index) => {
        event.stopPropagation()
        if (clickedTooltip === index) {
            setClickedTooltip(null)
        } else {
            setClickedTooltip(index)
            setActiveTooltip(index)
        }
    }
    const handleToolOutside = (event) => {
        if (!clickedTooltip) {
            setActiveTooltip(null)
        } else {
            setClickedTooltip(null)
            setActiveTooltip(null)
        }
    }
    const [product, setProduct] = useState()
    const [dateClosed, setDateClosed] = useState({ status: false, id: 0 })
    const [dynamicId, setDynamicId] = useState(null)
    const handleFocus = (id) => {
        setDynamicId(id)
        const inputElement = document.getElementById(id)
        if (inputElement) {
            inputElement.focus()
        } else {
            console.error('Input element not found')
        }
    }
    useEffect(() => {
        if (dynamicId) {
            const inputElement = document.getElementById(dynamicId)
            if (inputElement) {
                inputElement.focus()
            } else {
                console.error('Input element not found')
            }
        }
    }, [dynamicId])
    const history = useHistory()
    useEffect(() => {
        setProduct(props.data)
        if (allLocations?.length) {
            setProductLocation(
                allLocations.filter((item) => item?.id === parseInt(props?.data?.location))[0] ||
                    {},
            )
        }
    }, [props.data])
    const dateClosedUpdate = (data, id) => {
        setDateClosed({ status: data, id: id })
    }
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setAnchorEl(null)
    }

    const dateClosedReached = (data) => {
        if (product.past_inactive) {
            if (data) {
                setProduct({ ...product, past_inactive: 0 })
            }
        }
    }

    const isMobile = useMediaQuery('(max-width:360px)')

    const style = {
        zIndex: 99,
    }

    if (!props.featured) {
        if (
            product?.market_status === 'sold' &&
            (product?.source_type === 'buynow' || product?.buynow_source_type === 'buynow')
        ) {
            if (isMobile) {
                style.minHeight = !isHardOfferSelected ? '310px' : undefined
                style.maxHeight = !isHardOfferSelected ? 'fit-content' : undefined
            } else {
                style.minHeight = !isHardOfferSelected ? '330px' : undefined
                style.maxHeight = !isHardOfferSelected ? 'fit-content' : undefined
            }
        } else {
            if (isMobile) {
                style.minHeight = !isHardOfferSelected ? '310px' : undefined
                style.maxHeight = !isHardOfferSelected ? 'fit-content' : undefined
            } else {
                style.minHeight = !isHardOfferSelected ? '330px' : undefined
                style.maxHeight = !isHardOfferSelected ? 'fit-content' : undefined
            }
        }
    }

    return (
        <>
            <Fade in={true} timeout={600}>
                <div
                    // className={`productCardGrid ${
                    //     product.market_status === 'sold' ||
                    //     (product.market_status === 'closed' && 'buyNowSold')
                    // } ${
                    //     product?.market_status === 'sold' &&
                    //     (product?.source_type === 'buynow' ||
                    //         product?.buynow_source_type === 'buynow') &&
                    //     'buyNowSold'
                    // }`}
                    className={`productCardGrid 
                        ${
                            product?.market_status == 'sold' || product?.market_status == 'closed'
                                ? 'buyNowSold aucAward'
                                : ''
                        } 
                        ${
                            product?.market_status === 'sold' &&
                            (product?.source_type === 'buynow' ||
                                product?.buynow_source_type === 'buynow')
                                ? 'buyNowSold'
                                : ''
                        }`}
                    style={style}
                >
                    {/* <div className="innerBoxSD"></div> */}
                    {product ? (
                        <>
                            <div>
                                {isAuthenticated ? (
                                    !props?.favoriteRerenderHandler ? (
                                        product?.market_status == 'open' ? (
                                            <FavouriteCheckbox
                                                watchlisted={product.watchlistid}
                                                project_id={product.id}
                                                add_watchlist_message={'Added to Favorites'}
                                                remove_watchlist_message={'Removed from Favorites'}
                                            />
                                        ) : null
                                    ) : null
                                ) : (
                                    <div
                                        className="favoriteCheck beforeAuthFav"
                                        onClick={handleLoginPopup}
                                    >
                                        <span className="material-icons ntChckd">
                                            favorite_border
                                        </span>
                                    </div>
                                )}
                                <Share
                                    anchorEl={anchorEl}
                                    handleClose={handleClose}
                                    handleClick={handleClick}
                                    title={product.title}
                                    id={product.id}
                                />
                                <div className="pcgImg">
                                    <Link
                                        to={
                                            props.featured || props.pvSimilar
                                                ? `/product-view/${product.id}`
                                                : null
                                        }
                                        onClick={(e) => {
                                            if (!(props.featured || props.pvSimilar)) {
                                                e.preventDefault() // Prevent navigation
                                                props.handleProductClick(product) // Open modal or custom logic
                                            }
                                        }}
                                        className="asdasd"
                                    >
                                        <img
                                            className="cursorDecoy"
                                            src={
                                                isValidHttpUrl(props.data.avatar)
                                                    ? `${props.data.avatar}`
                                                    : `${global.site_url}/uploads/product/${props.data.avatar}`
                                            }
                                            onError={(e) => FALLBACK_IMAGE(e)}
                                            alt={product.title}
                                        />
                                    </Link>
                                    {isAuthenticated && (
                                        <>
                                            {product.bidtopstatus === 'outbid' && (
                                                <h4
                                                    className="productWinningStatus outbid"
                                                    id="bts_Outbid"
                                                >
                                                    {product.wprice < product.rprice
                                                        ? // ? 'Reserve not met'
                                                          'LOSING'
                                                        : 'LOSING'}
                                                </h4>
                                            )}
                                            {/* product.wprice >= product.rprice && */}
                                            {product.bidtopstatus === 'winner' && (
                                                <h4
                                                    className="productWinningStatus winning"
                                                    id="bts_Winning"
                                                >
                                                    WINNING
                                                </h4>
                                            )}
                                            {product.bidtopstatus === 'won' && (
                                                <h4
                                                    className="productWinningStatus won"
                                                    id="bts_Won"
                                                >
                                                    {'WON'}
                                                </h4>
                                            )}
                                            {product.bidtopstatus === 'lost' && (
                                                <h4
                                                    className="productWinningStatus lost"
                                                    id="bts_Lost"
                                                >
                                                    {'LOST'}
                                                </h4>
                                            )}
                                        </>
                                    )}
                                    {product.market_status === 'open' &&
                                    !product.future_active &&
                                    product?.user_id !== user?.admin_id ? (
                                        <>
                                            {product.market_status === 'open' &&
                                                product.past_inactive === 1 && (
                                                    <>
                                                        {product.buynow &&
                                                        !product.cart_removed &&
                                                        product.wprice < product.bprice ? (
                                                            <div className="buyProd">
                                                                <Buynow
                                                                    data={product}
                                                                    editQuantity={true}
                                                                    isOnlyBuynow={
                                                                        product.auction === 0
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    productLocation={
                                                                        productLocation
                                                                    }
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className="buyProd offer-below">
                                                                <PrimaryButton
                                                                    onClick={() =>
                                                                        handleFocus(
                                                                            `${
                                                                                product.id + 'offer'
                                                                            }`,
                                                                        )
                                                                    }
                                                                    label="Offer Below"
                                                                    btnSize="small"
                                                                />
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                        </>
                                    ) : product.market_status !== 'open' ? (
                                        <div className="buyProd">
                                            <PrimaryButton
                                                id="finished"
                                                label="Finished"
                                                btnSize="small"
                                            />
                                        </div>
                                    ) : null}
                                </div>

                                {product?.market_status == 'sold' &&
                                (product?.source_type == 'buynow' ||
                                    product?.buynow_source_type == 'buynow') ? (
                                    <Link
                                        to={
                                            props.featured || props.pvSimilar
                                                ? `/product-view/${product.id}`
                                                : '#'
                                        }
                                        onClick={(e) => {
                                            if (!(props.featured || props.pvSimilar)) {
                                                e.preventDefault() // Prevent navigation
                                                props.handleProductClick(product) // Open modal or custom logic
                                            }
                                        }}
                                        className="tileOverlay"
                                    >
                                        <img
                                            src="/assets/images/sold_stamp.png"
                                            alt="buyNowOverLay"
                                        />
                                        {/* <div className="overOverlay">
                                    </div> */}
                                    </Link>
                                ) : product.market_status !== 'open' &&
                                  product.market_status !== 'sold' ? (
                                    <Link
                                        to={
                                            props.featured || props.pvSimilar
                                                ? `/product-view/${product.id}`
                                                : '#'
                                        }
                                        onClick={(e) => {
                                            if (!(props.featured || props.pvSimilar)) {
                                                e.preventDefault() // Prevent navigation
                                                props.handleProductClick(product) // Open modal or custom logic
                                            }
                                        }}
                                    >
                                        <div className="overOverlay"></div>
                                    </Link>
                                ) : product.market_status === 'sold' &&
                                  (product?.source_type !== 'buynow' ||
                                      product?.buynow_source_type !== 'buynow') ? (
                                    <Link
                                        to={
                                            props.featured || props.pvSimilar
                                                ? `/product-view/${product.id}`
                                                : '#'
                                        }
                                        onClick={(e) => {
                                            if (!(props.featured || props.pvSimilar)) {
                                                e.preventDefault() // Prevent navigation
                                                props.handleProductClick(product) // Open modal or custom logic
                                            }
                                        }}
                                    >
                                        <div className="overOverlay"></div>
                                    </Link>
                                ) : null}

                                <Link
                                    to={
                                        props.featured || props.pvSimilar
                                            ? `/product-view/${product.id}`
                                            : '#'
                                    }
                                    onClick={(e) => {
                                        if (!(props.featured || props.pvSimilar)) {
                                            e.preventDefault() // Prevent navigation
                                            props.handleProductClick(product) // Open modal or custom logic
                                        }
                                    }}
                                >
                                    <h2 className="gridProdTitle" id="grid_product_title">
                                        {product.title}
                                    </h2>
                                </Link>
                                <div className="featureCurrent d-none">
                                    <h3 className="mb-0">
                                        Current Offer:{' '}
                                        <b>
                                            {currencyFormat(
                                                product?.wprice || product?.sprice || 0,
                                            )}
                                        </b>
                                    </h3>
                                </div>
                                <p className="pro-location">
                                    <a
                                        target="_blank"
                                        href={`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${productLocation?.place_id}`}
                                        rel="noreferrer"
                                    >
                                        {productLocation?.name || ''}
                                    </a>
                                    <span className="material-icons">location_on</span>
                                </p>
                                <Link
                                    to={
                                        props.featured || props.pvSimilar
                                            ? `/product-view/${product.id}`
                                            : '#'
                                    }
                                    onClick={(e) => {
                                        if (!(props.featured || props.pvSimilar)) {
                                            e.preventDefault() // Prevent navigation
                                            props.handleProductClick(product) // Open modal or custom logic
                                        }
                                    }}
                                >
                                    <div className="pro-description text-center">
                                        {' '}
                                        <p
                                            style={{
                                                display: 'flex',
                                            }}
                                        >
                                            {product?.disclaimer && (
                                                <span
                                                    style={{
                                                        textTransform: 'uppercase',
                                                        display: 'inline',
                                                        width: '100%',
                                                        overflow: 'unset',
                                                        whiteSpace: 'nowrap',
                                                        paddingRight: '2px',
                                                    }}
                                                >
                                                    {product?.disclaimer
                                                        ? product.disclaimer + ' '
                                                        : ''}{' '}
                                                </span>
                                            )}
                                            <span
                                                className="gridDesp"
                                                style={{ display: 'inline', textAlign: 'left' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: product?.desc_proc || '',
                                                }}
                                            />
                                        </p>
                                    </div>
                                </Link>
                                <div className="text-center">
                                    {product.market_status === 'open' && (
                                        <>
                                            <div className="gridBidInfo d-flex justify-content-center align-items-center retailGrid">
                                                <div
                                                    className={
                                                        product.asin_price === 0
                                                            ? 'd-none'
                                                            : 'retailAmnt mr-2'
                                                    }
                                                >
                                                    {currencyFormat(product.asin_price)}
                                                </div>
                                                {product.auction ? (
                                                    <p className="pro-price">
                                                        <span>
                                                            {currencyFormat(product.wprice)}
                                                        </span>
                                                    </p>
                                                ) : null}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            {props.featured && (
                                <div className="gridBidBox m-auto featuredGr">
                                    <PrimaryButton
                                        label="View"
                                        className="viewItemButton"
                                        btnSize="beforeAuthBtn"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            window.location.href = `/product-view/${product.id}`
                                        }}
                                    />
                                </div>
                            )}
                            {props.pvSimilar && (
                                <div className="gridBidBox m-auto featuredGr">
                                    <PrimaryButton
                                        label="View Item"
                                        className="viewItemButton"
                                        btnSize="beforeAuthBtn"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            window.location.href = `/product-view/${product.id}`
                                        }}
                                    />
                                </div>
                            )}
                            <>
                                {props.from === 'dashboard' &&
                                (props.action === 'won' || props.action === 'buynow') &&
                                product.buynowed &&
                                product.buynowed === user.id ? (
                                    <div className="actionAfterWin">
                                        {parseInt(product.buynowpaid, 10) === 1 ? (
                                            <>
                                                <SecondaryButton
                                                    id="invoice_viewed"
                                                    label={'View invoice'}
                                                    btnSize="small"
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            `invoice/${product.common_invoice}`,
                                                        )
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <PrimaryButton
                                                    id="make_pay_grid"
                                                    label={'Make payment'}
                                                    btnSize="small"
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            `checkout/invoice/${product.common_invoice}`,
                                                        )
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                ) : product.market_status === 'open' &&
                                  product.past_inactive === 1 &&
                                  !product.future_active &&
                                  product?.user_id !== user?.admin_id ? (
                                    <>
                                        <div className="gridBidBox grid-btm">
                                            <div className="buyNowButton">
                                                {product.market_status !== 'open' && (
                                                    <PrimaryButton
                                                        id="finished"
                                                        label="Finished"
                                                        btnSize="small"
                                                    />
                                                )}
                                            </div>
                                            {product.auction &&
                                            product?.user_id !== user?.admin_id ? (
                                                <>
                                                    {/* && product.wprice > product.rprice */}
                                                    {product.bidtopstatus === 'winner' ? (
                                                        <div className="grid-bid-buttons ">
                                                            <>
                                                                <div
                                                                    className="buyProd position-relative w-100 pt-2"
                                                                    style={{
                                                                        marginTop: '7px',
                                                                        marginBottom: '3px',
                                                                    }}
                                                                >
                                                                    <Bidding
                                                                        data={product}
                                                                        type={'proxy'}
                                                                        id={dynamicId}
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={`textIniti d-flex align-items-center justify-content-between homeCurrentSales w-100 ${
                                                                        isHardOfferSelected &&
                                                                        'flex-wrap'
                                                                    }`}
                                                                >
                                                                    <Bidding
                                                                        data={product}
                                                                        type={'hard'}
                                                                        cardType={'GridCard'}
                                                                        id={dynamicId}
                                                                        productHard={
                                                                            toggleHardOffer
                                                                        }
                                                                    />
                                                                    {product.market_status ===
                                                                        'open' &&
                                                                    product.date_closed ? (
                                                                        <div
                                                                            className={`gridTimer w-100 ${
                                                                                isHardOfferSelected &&
                                                                                'newTimeCls'
                                                                            }`}
                                                                        >
                                                                            <div>
                                                                                <img src="/assets/svg/timer.svg" />
                                                                            </div>
                                                                            <Timer
                                                                                date_added={
                                                                                    product.date_added
                                                                                }
                                                                                date_closed_check={
                                                                                    product.past_inactive
                                                                                }
                                                                                date_closed_reached={
                                                                                    dateClosedReached
                                                                                }
                                                                                date_closed={
                                                                                    product.date_closed
                                                                                }
                                                                                id={product.id}
                                                                                auction_Status={
                                                                                    product.market_status ===
                                                                                        'open' &&
                                                                                    product?.user_id !==
                                                                                        user?.admin_id &&
                                                                                    !product.future_active
                                                                                        ? ''
                                                                                        : 'start'
                                                                                }
                                                                            ></Timer>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="gridTimer closed">
                                                                            <img
                                                                                src="/assets/svg/timer-gray.svg"
                                                                                className="mr-2"
                                                                            />
                                                                            <span>Finished</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        </div>
                                                    ) : product.auctiontype == 'reverse' ? (
                                                        <div className="grid-bid-buttons">
                                                            <ReverseBidding
                                                                data={product}
                                                                type={'proxy'}
                                                            />

                                                            <ReverseBidding
                                                                data={product}
                                                                type={'hard'}
                                                            />
                                                        </div>
                                                    ) : product.custom_auctionlot_bid_type ? (
                                                        <div className="grid-bid-buttons">
                                                            <Bidding
                                                                data={product}
                                                                type={'proxy'}
                                                                id={dynamicId}
                                                            />

                                                            <Bidding
                                                                data={product}
                                                                type={'hard'}
                                                                id={dynamicId}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="grid-bid-buttons">
                                                            <div
                                                                className="buyProd pt-2 position-relative w-100"
                                                                style={{
                                                                    marginTop: '7px',
                                                                    marginBottom: '3px',
                                                                }}
                                                            >
                                                                <Bidding
                                                                    data={product}
                                                                    type={'proxy'}
                                                                    id={dynamicId}
                                                                    cardType={'GridCard'}
                                                                />
                                                            </div>
                                                            <div
                                                                className={`textIniti hardBid d-flex align-items-center justify-content-between homeCurrentSales w-100 ${
                                                                    isHardOfferSelected &&
                                                                    'flex-wrap'
                                                                }`}
                                                            >
                                                                <Bidding
                                                                    data={product}
                                                                    type={'hard'}
                                                                    id={dynamicId}
                                                                    cardType={'GridCard'}
                                                                    productHard={toggleHardOffer}
                                                                />
                                                                {product.market_status === 'open' &&
                                                                product.date_closed ? (
                                                                    <div
                                                                        className={`gridTimer w-100 ${
                                                                            isHardOfferSelected &&
                                                                            'newTimeCls'
                                                                        }`}
                                                                    >
                                                                        <div>
                                                                            <img src="/assets/svg/timer.svg" />
                                                                        </div>
                                                                        <Timer
                                                                            date_added={
                                                                                product.date_added
                                                                            }
                                                                            date_closed_check={
                                                                                product.past_inactive
                                                                            }
                                                                            date_closed_reached={
                                                                                dateClosedReached
                                                                            }
                                                                            date_closed={
                                                                                product.date_closed
                                                                            }
                                                                            id={product.id}
                                                                            auction_Status={
                                                                                product.market_status ===
                                                                                    'open' &&
                                                                                product?.user_id !==
                                                                                    user?.admin_id &&
                                                                                !product.future_active
                                                                                    ? ''
                                                                                    : 'start'
                                                                            }
                                                                        ></Timer>
                                                                    </div>
                                                                ) : (
                                                                    <div className="gridTimer closed">
                                                                        <img
                                                                            src="/assets/svg/timer-gray.svg"
                                                                            className="mr-2"
                                                                        />
                                                                        <span>Finished</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="grid-bid-buttons buyNowContainer">
                                                    <div
                                                        className={`textIniti d-flex align-items-center justify-content-between homeCurrentSales w-100`}
                                                    >
                                                        <div className="d-flex w-100 pt-2 position-relative flex-column-reverse align-items-end buyNowProBox">
                                                            <Buynow
                                                                data={product}
                                                                isOnlyBuynowTile={true}
                                                                isOnlyBuynow={
                                                                    product.auction === 0
                                                                        ? true
                                                                        : false
                                                                }
                                                                productLocation={productLocation}
                                                            />
                                                        </div>
                                                        {product.market_status === 'open' &&
                                                        product.date_closed ? (
                                                            <div
                                                                className={`gridTimer w-100 justify-content-center ${
                                                                    isHardOfferSelected &&
                                                                    'newTimeCls'
                                                                }`}
                                                            >
                                                                <div>
                                                                    <img src="/assets/svg/timer.svg" />
                                                                </div>
                                                                <Timer
                                                                    date_added={product.date_added}
                                                                    date_closed_check={
                                                                        product.past_inactive
                                                                    }
                                                                    date_closed_reached={
                                                                        dateClosedReached
                                                                    }
                                                                    date_closed={
                                                                        product.date_closed
                                                                    }
                                                                    id={product.id}
                                                                    auction_Status={
                                                                        product.market_status ===
                                                                            'open' &&
                                                                        product?.user_id !==
                                                                            user?.admin_id &&
                                                                        !product.future_active
                                                                            ? ''
                                                                            : 'start'
                                                                    }
                                                                ></Timer>
                                                            </div>
                                                        ) : (
                                                            <div className="gridTimer closed">
                                                                <img
                                                                    src="/assets/svg/timer-gray.svg"
                                                                    className="mr-2"
                                                                />
                                                                <span>Finished</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : product.buynowed && product.buynowed === user.id && false ? (
                                    <div className="actionAfterWin">
                                        {parseInt(product.buynowpaid, 10) === 1 ? (
                                            <>
                                                <SecondaryButton
                                                    id="invoice_viewed_grid"
                                                    label={'View invoice'}
                                                    btnSize="small"
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            `invoice/${product.common_invoice}`,
                                                        )
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <div className="biddingCnt d-flex align-items-center closed-bid">
                                                <div className="d-flex position-relative closedBidBox">
                                                    <CustomInput
                                                        label={`${currencyFormat(product.bprice)}`}
                                                        size="small"
                                                        disabled={true}
                                                    />
                                                    <PrimaryButton
                                                        label={'Closed'}
                                                        btnSize="small"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : product.market_status !== 'open' ||
                                  product.past_inactive === 0 ? (
                                    <div className="gridBidBox grid-btm pb-3 sold-bn-grid rr">
                                        {/* <div className="SUSMinH"></div> */}

                                        <div>
                                            {product.market_status === 'sold' &&
                                            (product?.source_type !== 'buynow' ||
                                                product?.buynow_source_type !== 'buynow') ? (
                                                <div className="biddingCnt d-flex flex-column align-items-center closed-bid">
                                                    <div className="d-flex position-relative closedBidBox">
                                                        <CustomInput
                                                            label={`${currencyFormat(
                                                                product.wprice,
                                                            )}`}
                                                            size="small"
                                                            disabled={true}
                                                        />
                                                        <PrimaryButton
                                                            label={'Sold'}
                                                            btnSize="small"
                                                        />
                                                    </div>
                                                    {props?.pendingText ? (
                                                        <div className="gridTimer closed">
                                                            <img
                                                                src="/assets/svg/timer-gray.svg"
                                                                className="mr-2"
                                                            />
                                                            <span>Offer Closed</span>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            ) : product?.source_type !== 'buynow' ||
                                              product?.buynow_source_type !== 'buynow' ? (
                                                <>
                                                    <div>
                                                        <PrimaryButton
                                                            label={
                                                                product.past_inactive === 0 &&
                                                                product.market_status === 'open'
                                                                    ? 'Offer Pending'
                                                                    : 'Unsold'
                                                            }
                                                            btnSize="small"
                                                        />
                                                    </div>
                                                    {props?.pendingText ? (
                                                        <div className="gridTimer closed">
                                                            <img
                                                                src="/assets/svg/timer-gray.svg"
                                                                className="mr-2"
                                                            />
                                                            <span>Offer Closed</span>
                                                        </div>
                                                    ) : null}
                                                </>
                                            ) : null}
                                        </div>
                                        <p className="offer_Closed mb-0">
                                            Offer Closed {dateFormatFrontDate(product.date_closed)}
                                        </p>
                                    </div>
                                ) : null}
                            </>
                        </>
                    ) : null}
                </div>
            </Fade>
        </>
    )
}

export default React.memo(Grid, (prevProps, nextProps) => {
    // Check if data that affects display has changed
    const dataChanged =
        prevProps.data.id !== nextProps.data.id ||
        prevProps.data.watchlistid !== nextProps.data.watchlistid ||
        prevProps.data.buynowprice !== nextProps.data.buynowprice ||
        prevProps.data.nextbid !== nextProps.data.nextbid ||
        prevProps.data.date_closed !== nextProps.data.date_closed ||
        prevProps.data.market_status !== nextProps.data.market_status ||
        prevProps.data.wprice !== nextProps.data.wprice ||
        prevProps.data.bpop_price !== nextProps.data.bpop_price ||
        prevProps.data.bidtopstatus !== nextProps.data.bidtopstatus ||
        prevProps.data.bid_count !== nextProps.data.bid_count ||
        prevProps.data.bid_or_not !== nextProps.data.bid_or_not

    const favChanged = prevProps.favoriteRerenderHandler !== nextProps.favoriteRerenderHandler

    return !dataChanged && !favChanged
})

// export default Grid
